export default __webpack_public_path__ + "static/hero-poster-98f3afb6d46df0d33805fb3e7830f9b9.png";